import { useDispatch } from "react-redux";
import { setPageTitle } from "../../Store/reducers/Common";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const ReportsList = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle(`Reports`));
    }, [dispatch]);
    return (
        <div className="reports-page">
            <ul>
                <li>
                    <Link to="members-attandance-report">
                        <i className="fa-solid fa-arrow-right me-2"></i>
                        Members Attendance
                    </Link>
                </li>
            </ul>
        </div>
    )
}

export default ReportsList;